export const SCORE_LEVELS = {
  critico:   { label: 'Crítico',   color: '#DC2626', bg: '#FEF2F2', text: '#991B1B', ring: 'pv-score-ring-critico' },
  bajo:      { label: 'Bajo',      color: '#F97316', bg: '#FFF7ED', text: '#9A3412', ring: 'pv-score-ring-bajo' },
  medio:     { label: 'Medio',     color: '#F59E0B', bg: '#FFF7E6', text: '#92400E', ring: 'pv-score-ring-medio' },
  bueno:     { label: 'Bueno',     color: '#2A9B68', bg: '#ECFDF5', text: '#065F46', ring: 'pv-score-ring-bueno' },
  excelente: { label: 'Excelente', color: '#059669', bg: '#D1FAE5', text: '#064E3B', ring: 'pv-score-ring-excelente' },
};

export const PRIORITY = {
  alta:  { label: 'Alta',  color: '#DC2626', bg: '#FEF2F2' },
  media: { label: 'Media', color: '#F59E0B', bg: '#FFF7E6' },
  baja:  { label: 'Baja',  color: '#6B7280', bg: '#F3F4F6' },
};

export const STATUS = {
  pendiente:  { label: 'Pendiente',  color: '#6B7280', dot: '#9CA3AF' },
  en_curso:   { label: 'En curso',   color: '#2563EB', dot: '#2563EB' },
  completada: { label: 'Completada', color: '#2A9B68', dot: '#2A9B68' },
};

export const CATEGORY_META = {
  gobernanza: { label: 'Gobernanza', icon: 'Building2' },
  rat:        { label: 'RAT',        icon: 'Database' },
  documentos: { label: 'Documentos', icon: 'FileText' },
  cmp:        { label: 'Cookies',    icon: 'Cookie' },
  arco:       { label: 'ARCO+',      icon: 'Users' },
  brechas:    { label: 'Brechas',    icon: 'AlertTriangle' },
  seguridad:  { label: 'Seguridad',  icon: 'ShieldCheck' },
  dpia:       { label: 'DPIA',       icon: 'FileSearch' },
};

export const INDUSTRIAS = [
  { value: 'retail',     label: 'Retail / Comercio' },
  { value: 'salud',      label: 'Salud' },
  { value: 'fintech',    label: 'Fintech / Financiero' },
  { value: 'educacion',  label: 'Educación' },
  { value: 'ecommerce',  label: 'E-commerce' },
  { value: 'servicios',  label: 'Servicios profesionales' },
  { value: 'tecnologia', label: 'Tecnología / Software' },
  { value: 'industria',  label: 'Industria / Manufactura' },
  { value: 'otro',       label: 'Otro' },
];

export const TAMANOS = [
  { value: 'micro',      label: '1 a 9 personas' },
  { value: 'pequena',    label: '10 a 49 personas' },
  { value: 'mediana',    label: '50 a 199 personas' },
  { value: 'grande',     label: '200 a 500 personas' },
  { value: 'enterprise', label: 'Más de 500 personas' },
];

export const SECTORES = [
  { value: 'privado', label: 'Privado' },
  { value: 'publico', label: 'Público' },
  { value: 'mixto',   label: 'Mixto' },
];

export function formatDate(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch (_e) { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('es-CL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch (_e) { return iso; }
}
